import { useEffect, useState } from "react";
import { PropagateLoader } from "react-spinners";
import CardHeader from "../atoms/CardHeader";
import LogosDashboard from "../atoms/dashboard/LogosDashboard";
import StatsDashboard from "../organisms/dashboard/StatsDashboard";
import { GET_GASTOS } from "../../api/apiGastos";
import { GET_INMUEBLES } from "../../api/apiInmuebles";
import Heading from "../atoms/Heading";
import { useSession } from "../../context/SessionContext";
import UserDashboard from "../organisms/dashboard/UserDashboard";

const DashboardTemplate = () => {
    const [gastos, setGastos] = useState([]);
    const [inmubles, setInmuebles] = useState([]);
    const [loading, setLoading] = useState(true);
    const { user } = useSession();

    useEffect(() => {
        const getInmuebles = async () => {
            try {
                const gastosData = await GET_GASTOS();
                setGastos(gastosData)
            } catch (errorGastos) {
                console.error(errorGastos);
            }
            try {
                const inmublesData = await GET_INMUEBLES();
                setInmuebles(inmublesData);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        }

        getInmuebles();
    }, []);

    return (
        <div className="w-full flex flex-col gap-4">
            <CardHeader children={<Heading text="BIENVENIDO" />} />
            {loading ?
                <div className="h-64 w-full flex justify-center items-center"> <PropagateLoader color="red" /> </div>
            :
                (inmubles && (
                    user?.role === "Resident" ?
                            <>
                                <UserDashboard/>
                            </>
                        :
                            <>
                                <LogosDashboard/>
                                <StatsDashboard dataInmuebles={inmubles || []} dataGastos={gastos || []}/>
                            </>
                    )
                )
            }
        </div>
    );
};

export default DashboardTemplate;